<script>
  import { fade, fly } from "svelte/transition";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
</script>

<div
  class="relative w-full overflow-hidden bg-blue-400 bg-opacity-75 rounded-lg shadow-2xl lg:rounded-lg"
>
  <div class="p-0 text-center lg:p-8 lg:text-center">
    <div
      transition:fly={{ y: 200, duration: 500, delay: 500 }}
      class="relative w-full py-2 overflow-hidden bg-white bg-opacity-100 rounded-b-full shadow-xl rounded-lt-lg lg:rounded-lg lg:bg-transparent lg:shadow-none lg:bg-opacity-75"
    >
      <h1
        transition:fade={{ delay: 100, duration: 500 }}
        class="pt-0 mb-0 font-bold text-gray-800 lg:text-2xl md:text-2xl text-1xl lg:pt-0"
      >
        {settings.data.pen.nm}
      </h1>
      <h4
        transition:fade={{ delay: 150, duration: 500 }}
        class="relative clear-both px-3 py-1 mb-0 text-sm text-gray-700 uppercase rounded-full lg:text-xl "
      >
        {settings.data.pen.nik}
      </h4>
    </div>
    <div
      transition:fly={{ y: 200, duration: 500, delay: 500 }}
      class="w-full mb-40 lg:mb-16"
    >
      <h4
        transition:fade={{ delay: 200, duration: 500 }}
        class="relative clear-both px-3 py-1 mt-2 mb-0 text-2xl font-bold text-red-600 uppercase rounded-full"
      >
        {settings.data.saldo}
      </h4>
      <span
        transition:fade={{ delay: 250, duration: 500 }}
        class="clear-both px-3 py-1 text-xs text-red-100 bg-red-700 rounded-full shadow-lg"
      >
        RukunPoints
      </span>
    </div>
  </div>
</div>
